// libs
import React, { memo, useCallback } from 'react';
import { styled } from '@nykaa/ui-components';
import isEmpty from 'lodash/isEmpty';
import { useHistory, useLocation } from 'react-router-dom';

// global components
import ModalBase from 'shared/components/Modal';
import OtpFlow from 'shared/layouts/OTPVerification/Mobile';

// constants
import { AUTH_URI } from 'shared/constants/uri';
import { DEFAULT_LOGIN_LOCATION } from 'shared/components/AuthModal/constants';

// styles
export const Modal = styled(ModalBase)`
  width: 480px;
  min-height: 360px;
  border: none;
  border-radius: ${({ theme }) => theme.spacing.spacing80};
  padding: 0;
  
  &.auth-modal {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
`;

// defs
interface IAuthModalProps {
  onHide: VoidFunction;
  redirectUrl?: string;
  isLoggedIn: boolean;
  loginLocation?: string;
}

function AuthModal({ onHide, redirectUrl, isLoggedIn, loginLocation = DEFAULT_LOGIN_LOCATION }: IAuthModalProps) {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);

  const onModalClose = useCallback(
    (closeOnly) => {
      if (isEmpty(params.get(AUTH_URI.PARAM_KEY)) === false) {
        params.delete(AUTH_URI.PARAM_KEY);
        history.push(pathname + '?' + params.toString());
      }

      if (redirectUrl && !closeOnly) {
        window.location.href = redirectUrl;
        return;
      }

      onHide();
    },
    [history, onHide, params, pathname, redirectUrl]
  );

  return (
    <Modal
      className="auth-modal"
      onHide={onModalClose}
      showCrossIcon={false}
      onEscapeHide={false}
      allowBackdropClick={false}
    >
      <OtpFlow isUserLoggedIn={isLoggedIn} hide={onModalClose} type={loginLocation} />
    </Modal>
  );
}

export default memo(AuthModal);
